var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#5b00db","fillRule":"nonzero","stroke":"none","strokeWidth":"1","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"10","strokeDasharray":"","strokeDashoffset":"0","fontFamily":"none","fontWeight":"none","fontSize":"none","textAnchor":"none","style":{"mixBlendMode":"normal"}},React.createElement("g",{"transform":"scale(8,8)"},React.createElement("path",{"d":"M4.01758,4l9.07422,13.60938l-8.75586,10.39063h2.61523l7.29492,-8.65625l5.77148,8.65625h0.53516h7.46289l-9.30273,-13.95703l8.46289,-10.04297h-2.61523l-7.00195,8.31055l-5.54102,-8.31055zM7.75586,6h3.19141l13.33203,20h-3.19141z"}))));
}

Twitter.defaultProps = {"x":"0px","y":"0px","width":"100","height":"100","viewBox":"0,0,256,256"};

module.exports = Twitter;

Twitter.default = Twitter;
